define('plugin/client-login/view/ClientProfileFormBehavior',['require','collection/CountryCollection','collection/StateCollection'],function (require) {

    var CountryCollection = require('collection/CountryCollection');
    var StateCollection = require('collection/StateCollection');

    return Marionette.Behavior.extend({

        countryCollection: null,
        stateCollection: null,
        model: null,

        ui: {
            'country': '#sb_country_select_container :input',
            'state': '#sb_state_select_container',
            'withAddress': '#sb_with_address_container :input',
            'address': '#sb_address_container'
        },
        events: {
            'change @ui.country': 'handleCountry',
            'change @ui.withAddress': 'handleWithAddress'
        },
        _countryWithState: 'US',
        _data: {
            show_address: false
        },

        initialize: function () {
            this.model = this.getOption('model');
            this.countryCollection = CountryCollection.getInstance();
            this.stateCollection = new StateCollection.getInstance();

            this.listenTo(this.countryCollection, 'sync', this.view.render);
            this.listenTo(this.stateCollection, 'sync', this.view.render);
        },

        handleCountry: function () {
            var value = this.model.get('country_id');
            if (this.ui.country.length) {
                value = this.ui.country.val();
            }

            if (value === this._countryWithState) {
                this.ui.state.show();
            } else {
                this.ui.state.hide();
            }
        },

        handleWithAddress: function (event, forceWithAddress) {
            var config = Config.getInstance();

            if (this.ui.withAddress.is(':checked') || config.getBooleanOption('client_login_require_address') || forceWithAddress) {
                this.ui.address.show();
            } else {
                this.ui.address.hide();
            }
        },

        isEditMode: function () {
            return this.getOption('mode') === 'edit';
        },

        onRender: function () {
            var addrFields = ['address1', 'address2', 'city', 'zip'];
            var filledFields = _.filter(addrFields, function (field) {
                if (this.model) {
                    return this.model.get(field);
                }
                return false;
            }, this);

            var showAddr = filledFields.length > 0;

            this.ui.withAddress.prop('checked', showAddr);

            this.handleCountry();
            this.handleWithAddress(null, showAddr);
        },

        onBeforeRender: function() {
            var config = Config.getInstance();

            this._data.allow_address = config.getBooleanOption('client_login_allow_address');
            this._data.require_address = config.getBooleanOption('client_login_require_address');

            this._data.countries = this.getCountryList();
            this._data.states = this.getStateList();

            this.view.mergeOptions({'externalData': this._data}, ['externalData']);
        },

        getCountryList: function () {
            this.countryCollection.load();
            return this.countryCollection.toJSON();
        },

        getStateList: function () {
            this.stateCollection.load();
            return this.stateCollection.toJSON();
        }

    });

});
